// extracted by mini-css-extract-plugin
export default {"profilePlaceholder":"profilePlaceholder---rNR74"};